(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ulti-finder-runtime"] && !Shopify.designMode) return;
  try {
    function scoreDesk(desk, answers) {
    if (answers.width && answers.width !== "unsure" && !desk.widths.includes(answers.width))
        return null;
    const requestedWeight = Number(answers.weight);
    if (requestedWeight && requestedWeight > desk.load)
        return null;
    if (answers.feature === "capacity" && desk.load < 130)
        return 1;
    if (answers.feature === "rgb" && desk.name.includes("Aura"))
        return 0;
    if (answers.feature === "cable" && desk.name.includes("Arc"))
        return 0;
    return desk.load;
}

function scoreChair(chair, answers) {
    let score = 0;
    if (answers.setup === "gaming")
        score += chair.tags.includes("gaming") ? 10 : 0;
    if (answers.recline === "deep")
        score += chair.tags.includes("deep-recline") ? 6 : 0;
    if (answers.headrest === "essential")
        score += chair.tags.includes("3d-headrest") ? 5 : 0;
    if (answers.adjustment === "seat-depth")
        score += chair.tags.includes("seat-depth") ? 5 : 0;
    if (answers.duration === "long-sessions")
        score += chair.tags.includes("deep-recline") || chair.tags.includes("fit-range") ? 3 : 0;
    if (answers.setup === "home" && chair.tags.includes("everyday"))
        score += 4;
    if (answers.adjustment === "lumbar" && chair.tags.includes("everyday"))
        score += 3;
    if (chair.tags.includes("fit-range"))
        score += 1;
    return score;
}

function findCompatibleMonitorArms(products, answers) {
    const requestedSize = Number(answers.size);
    const requestedWeight = Number(answers.weight);
    const requestedVesa = Number(answers.vesa);
    return products.filter((arm) => {
        if (answers.configuration && arm.configuration !== answers.configuration)
            return false;
        if (requestedSize && (requestedSize < arm.sizes[0] || requestedSize > arm.sizes[1]))
            return false;
        if (requestedWeight && requestedWeight > arm.capacity)
            return false;
        if (requestedVesa && !arm.vesa.includes(requestedVesa))
            return false;
        if (answers.display === "curved" && !arm.curved)
            return false;
        if (!answers.mounting)
            return true;
        return answers.mounting === "wall"
            ? arm.mounting === "wall"
            : arm.mounting === "both" || arm.mounting === answers.mounting;
    }).sort((a, b) => a.capacity - b.capacity);
}

function rank(kind, products, answers) {
 if (kind === 'monitor') return findCompatibleMonitorArms(products, {...answers, vesa: answers.vesa === 'unsure' ? '' : answers.vesa});
 if (kind === 'chair') return products.map(p => ({p, score: scoreChair(p, answers)})).sort((a,b) => b.score-a.score).map(x => x.p);
 const scored = products.map(p => ({p, score: scoreDesk(p, answers)})).filter(x => x.score !== null);
 if (answers.feature === 'rgb') scored.sort((a,b) => (a.p.name.includes('Aura') ? -1 : 1) - (b.p.name.includes('Aura') ? -1 : 1));
 else if (answers.feature === 'capacity' || answers.feature === 'cable') scored.sort((a,b) => (a.p.name.includes('Arc') ? -1 : 1) - (b.p.name.includes('Arc') ? -1 : 1));
 else scored.sort((a,b) => b.score-a.score);
 return scored.map(x => x.p);
}
(() => {
  function mount(root) {
    if (root.dataset.finderMounted) return;
    root.dataset.finderMounted = 'true';
    const labels = JSON.parse(root.querySelector('[data-finder-labels]').dataset.finderLabels);
    const form = root.querySelector('form');
    const questions = [...root.querySelectorAll('[data-question]')];
    const cards = [...root.querySelectorAll('[data-finder-product]')];
    const products = cards.map((card, index) => {
      try { return { ...JSON.parse(card.dataset.facts), index }; }
      catch { return null; }
    }).filter(Boolean);
    const results = root.querySelector('.ulti-finder-results');
    const resultGrid = root.querySelector('.ulti-finder-result-grid');
    const next = root.querySelector('[data-next]');
    const back = root.querySelector('[data-back]');
    const restart = root.querySelector('[data-restart]');
    const error = root.querySelector('.ulti-finder-error');
    let step = 0;
    function render(focus = true) {
      const done = step === questions.length;
      questions.forEach((q, index) => { q.hidden = index !== step; });
      results.hidden = !done;
      next.hidden = done;
      restart.hidden = !done;
      back.disabled = step === 0;
      error.hidden = true;
      next.textContent = step === questions.length - 1 ? labels.recommend : labels.next;
      root.querySelector('.ulti-finder-status').textContent = `${labels.step} ${step + 1} ${labels.of} ${questions.length + 1}: ${done ? labels.result : questions[step].dataset.stepLabel}`;
      root.querySelectorAll('.ulti-finder-progress span').forEach((bar, index) => { bar.classList.toggle('is-active', index <= step); });
      if (done) {
        const answers = Object.fromEntries(new FormData(form));
        const matches = rank(root.dataset.ultiFinder, products, answers).slice(0, 2);
        resultGrid.replaceChildren();
        matches.forEach((product, index) => {
          const fragment = cards[product.index].content.cloneNode(true);
          fragment.querySelector('[data-rank]').textContent = index === 0 ? labels.best : labels.alternative;
          fragment.querySelector('article').classList.toggle('is-best', index === 0);
          fragment.querySelector('[data-checks]').hidden = index !== 0;
          resultGrid.append(fragment);
        });
        const message = matches.length === 0 ? labels.no_match : matches.length === 1 ? labels.no_alternative : '';
        if (message) {
          const p = document.createElement('p');
          p.className = 'ulti-finder-no-match';
          p.textContent = message;
          resultGrid.append(p);
        }
      }
      if (focus) {
        const heading = done ? results.querySelector('h3') : questions[step].querySelector('legend');
        heading.focus({ preventScroll: true });
        const bounds = form.getBoundingClientRect();
        if (bounds.top < 0 || bounds.top > innerHeight * 0.7) form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }
    }
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (step >= questions.length) return;
      const input = questions[step].querySelector('input[type="number"]');
      if (input && (!input.validity.valid || (input.value !== '' && (!Number.isFinite(Number(input.value)) || Number(input.value) <= 0)))) {
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      input?.removeAttribute('aria-invalid');
      step += 1;
      render();
    });
    back.addEventListener('click', () => { step = Math.max(0, step - 1); render(); });
    restart.addEventListener('click', () => {
      form.reset();
      form.querySelectorAll('[aria-invalid]').forEach(input => input.removeAttribute('aria-invalid'));
      step = 0;
      render();
    });
    root.addEventListener('shopify:block:select', event => {
      const index = questions.findIndex(q => q.dataset.blockId === event.detail.blockId);
      step = index >= 0 ? index : questions.length;
      render(false);
    });
    root.querySelector('.ulti-finder-interactive').hidden = false;
    render(false);
  }
  const init = scope => {
    scope.querySelectorAll('[data-ulti-finder]').forEach(mount);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
